const ALLOWED_TAGS = new Set([
  'p', 'strong', 'em', 'ul', 'ol', 'li', 'code', 'pre',
  'br', 'a', 'h1', 'h2', 'h3', 'blockquote', 'span', 'div',
  'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th', 'caption',
]);

const ALLOWED_ATTRS: Record<string, Set<string>> = {
  a: new Set(['href']),
  td: new Set(['align', 'colspan', 'rowspan']),
  th: new Set(['align', 'colspan', 'rowspan', 'scope']),
};

function isSafeHref(href: string): boolean {
  const lower = href.trim().toLowerCase();
  return lower.startsWith('https://') || lower.startsWith('mailto:');
}

function cleanNode(node: Node): Node | null {
  if (node.nodeType === Node.TEXT_NODE) return node.cloneNode();
  if (node.nodeType !== Node.ELEMENT_NODE) return null;

  const el = node as Element;
  const tag = el.tagName.toLowerCase();
  if (!ALLOWED_TAGS.has(tag)) return null;

  const clean = document.createElement(tag);
  const allowedForTag = ALLOWED_ATTRS[tag] ?? new Set();
  for (const attr of Array.from(el.attributes)) {
    if (!allowedForTag.has(attr.name)) continue;
    if (attr.name === 'href' && !isSafeHref(attr.value)) continue;
    clean.setAttribute(attr.name, attr.value);
  }

  for (const child of Array.from(el.childNodes)) {
    const cleanedChild = cleanNode(child);
    if (cleanedChild) clean.appendChild(cleanedChild);
  }
  return clean;
}

export function sanitizeHtml(dirty: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${dirty}</div>`, 'text/html');
  const root = doc.body.firstElementChild;
  if (!root) return '';

  const out = document.createElement('div');
  for (const child of Array.from(root.childNodes)) {
    const cleaned = cleanNode(child);
    if (cleaned) out.appendChild(cleaned);
  }
  return out.innerHTML;
}
